var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOxLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 46,
    viewBox: "0 0 121 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4559 23.1828V8.76056H46.9171V11.7122H40.8409V14.4719H46.5317V17.4235H40.8409V20.2312H47.0079V23.1828H37.4559Z",
    fill: "#0C0C18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3552 23.1828H58.4152L52.4349 13.982V23.1828H49.0516V8.76056H52.9917L58.9634 17.9871V8.76056H62.3552V23.1828Z",
    fill: "#0C0C18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4829 23.1828V8.76056H73.9424V11.7122H67.8662V14.4719H73.5587V17.4235H67.8662V20.2312H74.0332V23.1828H64.4829Z",
    fill: "#0C0C18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1435 23.1828H84.4039L81.5089 18.1926H79.4618V23.1828H76.0768V8.76056H81.7213C82.925 8.76056 83.9528 8.94671 84.8048 9.31902C85.6051 9.64754 86.2871 10.2107 86.7611 10.9344C87.2289 11.6999 87.464 12.585 87.4378 13.4817C87.4624 14.358 87.234 15.2227 86.78 15.9725C86.3232 16.6786 85.6675 17.2336 84.8956 17.5674L88.1435 23.1828ZM79.4618 15.5494H81.4609C82.282 15.5494 82.9102 15.3855 83.3453 15.0578C83.7804 14.73 83.9951 14.256 83.9894 13.6359C83.9894 13.0078 83.7747 12.5299 83.3453 12.2021C82.9159 11.8743 82.2878 11.711 81.4609 11.7122H79.4618V15.5494Z",
    fill: "#0C0C18"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7581 12.6544C99.3676 12.2554 98.8954 11.9457 98.3739 11.7464C97.8137 11.5288 97.2173 11.4195 96.6163 11.4244C96.0433 11.4165 95.4747 11.5243 94.9444 11.7413C94.4523 11.947 94.0109 12.2574 93.651 12.6509C93.2801 13.0594 92.9952 13.5382 92.8133 14.0591C92.6105 14.6497 92.5114 15.271 92.5204 15.8955C92.5121 16.5368 92.6165 17.1746 92.8287 17.7798C93.0182 18.3202 93.3141 18.8171 93.699 19.2411C94.0739 19.6483 94.5311 19.9712 95.0403 20.1884C95.5873 20.4204 96.1763 20.5371 96.7705 20.531C97.2362 20.5364 97.6995 20.4635 98.1409 20.3151C98.5424 20.1773 98.9143 19.9652 99.2373 19.6899C99.5612 19.4094 99.8311 19.0721 100.034 18.6946C100.258 18.2795 100.415 17.8322 100.502 17.3687H96.6814V14.7991H103.479L103.575 16.0873C103.587 17.1106 103.418 18.128 103.075 19.092C102.762 19.9529 102.28 20.7423 101.656 21.4132C101.044 22.0705 100.298 22.5887 99.4685 22.9327C98.5754 23.2989 97.6175 23.4813 96.6523 23.4689C95.6289 23.4783 94.6139 23.2838 93.6664 22.8967C92.7666 22.5289 91.9473 21.9889 91.2544 21.307C90.5627 20.6233 90.0151 19.8078 89.6442 18.9087C88.878 17.0127 88.8744 14.8939 89.6339 12.9953C90.001 12.1082 90.5381 11.3016 91.215 10.621C91.8936 9.94016 92.7007 9.40096 93.5893 9.03467C94.5244 8.65096 95.5268 8.45817 96.5375 8.46765C97.5249 8.46494 98.5048 8.63899 99.4309 8.98157C100.353 9.31986 101.206 9.8212 101.951 10.4616L99.7581 12.6544Z",
    fill: "#0C0C18"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.651 23.1828H105.267V8.76056H108.651V23.1828Z",
    fill: "#0C0C18"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.785 23.1828V8.76056H120.246V11.7122H114.17V14.4719H119.863V17.4235H114.17V20.2312H120.337V23.1828H110.785Z",
    fill: "#0C0C18"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7596 37.3583H36.005L40.4281 26.1618H43.1861L47.5973 37.3583H44.8427L44.0255 35.157H39.5802L38.7596 37.3583ZM40.4281 32.865H43.1861L41.7986 29.1922L40.4281 32.865Z",
    fill: "#0C0C18"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6054 37.3583H47.8508L52.2705 26.1618H55.032L59.4431 37.3583H56.6885L55.8679 35.157H51.426L50.6054 37.3583ZM52.2705 32.865H55.032L53.6512 29.1922L52.2705 32.865Z",
    fill: "#0C0C18"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7218 37.3583H67.6657L63.0302 30.2149V37.3583H60.3989V26.1618H63.4584L68.0957 33.3206V26.1618H70.7218V37.3583Z",
    fill: "#0C0C18"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.38 37.3583V26.1618H76.1933C77.542 26.1618 78.7115 26.3902 79.7016 26.847C80.6401 27.264 81.4405 27.9396 82.0091 28.7947C82.546 29.6879 82.8296 30.7103 82.8296 31.7523C82.8296 32.7944 82.546 33.8168 82.0091 34.7099C81.4417 35.5674 80.6411 36.245 79.7016 36.6628C78.7115 37.1196 77.542 37.348 76.1933 37.348L72.38 37.3583ZM75.0061 35.0662H76.2841C77.0022 35.0873 77.7167 34.9565 78.3808 34.6825C78.923 34.4519 79.3807 34.0594 79.6913 33.5587C79.987 33.0053 80.1418 32.3875 80.1418 31.76C80.1418 31.1326 79.987 30.5148 79.6913 29.9613C79.3807 29.4607 78.923 29.0682 78.3808 28.8376C77.7167 28.5636 77.0022 28.4328 76.2841 28.4538H75.0061V35.0662Z",
    fill: "#0C0C18"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1436 37.3583V26.1618H91.4891V28.4538H86.7714V30.5952H91.1894V32.8907H86.7714V35.0662H91.5679V37.3583H84.1436Z",
    fill: "#0C0C18"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.611 37.3583H93.1456V26.1618H95.7735V35.0697H100.611V37.3583Z",
    fill: "#0C0C18"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M101.67 37.3583V26.1618H109.015V28.4538H104.298V30.5952H108.717V32.8907H104.298V35.0662H109.094V37.3583H101.67Z",
    fill: "#0C0C18"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M120.997 37.3583H117.935L113.3 30.2149V37.3583H110.674V26.1618H113.733L118.372 33.3206V26.1618H121L120.997 37.3583Z",
    fill: "#0C0C18"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6076 27.647L25.7387 29.0637L6.01799 26.3896L5.60172 25.4577L5.58801 23.5049L27.0732 26.5627L27.6076 27.647Z",
    fill: "url(#paint0_linear_1121_2467)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5725 20.3717L25.0431 22.1156L3.89201 19.2667L3.56482 18.1824L5.58794 16.5567L24.954 19.4603L25.5725 20.3717Z",
    fill: "url(#paint1_linear_1121_2467)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25,
    d: "M27.6076 27.647L25.7387 29.0637L6.01799 26.3896L5.60172 25.4577L5.58801 23.5049L27.0732 26.5627L27.6076 27.647Z",
    fill: "url(#paint2_linear_1121_2467)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25,
    d: "M25.5725 20.3717L25.0431 22.1156L3.89201 19.2667L3.56482 18.1824L5.58794 16.5567L24.954 19.4603L25.5725 20.3717Z",
    fill: "url(#paint3_linear_1121_2467)"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38503 15.6882C4.19188 15.2068 11.2651 11.1914 18.0402 7.34387C24.6526 3.59742 30.9909 0 30.9909 0L30.2834 3.88521C30.2834 3.88521 18.7614 10.095 11.4655 14.0316L6.81971 16.5413C6.32635 16.8085 5.96318 17.0021 5.77475 17.1083C5.58631 17.2145 5.38417 17.331 5.22143 17.4389C3.70024 18.4513 3.91608 19.2667 3.91608 19.2667C3.08354 19.0149 2.56962 18.6449 2.32123 18.2201C1.81416 17.3687 2.32465 16.3186 3.38503 15.6882Z",
    fill: "url(#paint4_linear_1121_2467)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25,
    d: "M11.4656 14.0316L18.0403 7.35072C24.6527 3.59742 30.991 0 30.991 0L30.2835 3.88521C30.2835 3.88521 18.7615 10.095 11.4656 14.0316Z",
    fill: "url(#paint5_linear_1121_2467)"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9909 0.0548248L30.2834 3.95031C30.2834 3.95031 8.69375 22.6911 7.45521 23.743C6.21667 24.7948 5.68562 25.9528 6.21667 26.4188C5.33102 26.5729 2.85394 24.8564 4.79997 22.6894C6.746 20.5224 30.9909 0.0548248 30.9909 0.0548248Z",
    fill: "url(#paint6_linear_1121_2467)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6059 30.1497C26.799 30.6294 19.7258 34.6448 12.9507 38.4923C6.33831 42.2388 0 45.8311 0 45.8311L0.707492 41.9459C0.707492 41.9459 12.2295 35.736 19.5288 31.7994L24.1712 29.2932L25.2179 28.7262C25.4218 28.6131 25.6068 28.5035 25.7695 28.3956C27.2907 27.3832 27.0749 26.5677 27.0749 26.5677C27.9023 26.8144 28.4127 27.1896 28.668 27.6144C29.1768 28.4607 28.6663 29.5125 27.6059 30.1497Z",
    fill: "url(#paint7_linear_1121_2467)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25,
    d: "M19.5288 31.7995L12.9541 38.4804C6.33831 42.2388 0 45.8311 0 45.8311L0.707492 41.9459C0.707492 41.9459 12.2295 35.7361 19.5288 31.7995Z",
    fill: "url(#paint8_linear_1121_2467)"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 45.7763L0.707492 41.8808C0.707492 41.8808 22.292 23.14 23.5357 22.0865C24.7794 21.0329 25.3053 19.8783 24.7742 19.4124C25.6599 19.2565 28.1369 20.973 26.1909 23.1417C24.2449 25.3104 0 45.7763 0 45.7763Z",
    fill: "url(#paint9_linear_1121_2467)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1121_2467",
    x1: 5.58801,
    y1: 26.2851,
    x2: 27.6076,
    y2: 26.2851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#81CAA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8CD5EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1121_2467",
    x1: 3.56482,
    y1: 19.3353,
    x2: 25.5725,
    y2: 19.3353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#81CAA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8CD5EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1121_2467",
    x1: 5.58801,
    y1: 26.2851,
    x2: 27.6076,
    y2: 26.2851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#4D4D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7D7D7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ABABAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F9F9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BEBEBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#8D8D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4D4D4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1121_2467",
    x1: 3.56482,
    y1: 19.3353,
    x2: 25.5725,
    y2: 19.3353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#4D4D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7D7D7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ABABAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F9F9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BEBEBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#8D8D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4D4D4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1121_2467",
    x1: 2.12422,
    y1: 9.63251,
    x2: 30.9909,
    y2: 9.63251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#81CAA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8CD5EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1121_2467",
    x1: 30.991,
    y1: 7.01496,
    x2: 11.4639,
    y2: 7.01496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#4D4D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1121_2467",
    x1: 4.07364,
    y1: 13.2419,
    x2: 30.9909,
    y2: 13.2419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#81CAA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8CD5EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1121_2467",
    x1: 0,
    y1: 36.1968,
    x2: 28.8667,
    y2: 36.1968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#81CAA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8CD5EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1121_2467",
    x1: 0,
    y1: 38.8144,
    x2: 19.5254,
    y2: 38.8144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#4D4D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1121_2467",
    x1: 0,
    y1: 32.5892,
    x2: 26.9172,
    y2: 32.5892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#81CAA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8CD5EA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxLogo);
export default __webpack_public_path__ + "static/media/oxLogo.b76ca564283780b7bd9bd90447297386.svg";
export { ForwardRef as ReactComponent };